"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("../core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function CompetitionNavbarItems({
  competition,
  match: {
    url,
    params: {
      yearID
    }
  }
}) {
  if (!competition) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url,
    style: {
      marginLeft: '1rem'
    }
  }, competition.shortName), !competition.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: url + '/set-up'
  }, "Set-Up"), !competition.isPublished || !competition.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: url + '/manage-entries'
  }, "Manage-Entries"), !competition.isPublished || !competition.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: url + '/finance'
  }, "Finance"), !competition.isAdministratedByUser && !competition.displayStartList ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: url + '/start-list'
  }, "Start-List"));
}
var _ref = {
  shortName: true,
  isAdministratedByUser: true,
  isPublished: true,
  displayStartList: true
};
var _default = exports.default = (0, _reactBicycle.connect)(CompetitionNavbarItems, props => {
  if (!/^[0-9]{4}$/.test(props.match.params.yearID)) {
    return {};
  }
  return {
    ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref
  };
}, undefined, {
  renderLoading: true
});